import { render, staticRenderFns } from "./defaultshopthumb.vue?vue&type=template&id=4d2c0ee2&"
import script from "./defaultshopthumb.vue?vue&type=script&lang=js&"
export * from "./defaultshopthumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports